<template>
	<div class="flex flex-col md:flex-row gap-12">
		<section class="md:w-7/12 flex flex-col gap-6">
			<div class="flex flex-col gap-6">
				<h2 class="font-bold text-xl md:text-3xl">Senaste avsnitten</h2>
				<ul class="grid grid-cols-1 md:grid-cols-2 gap-6">
					<li v-for="episode in store.episodes.slice(0, 6)" :key="episode.linkid">
						<EpisodeCard :episode="episode" />
					</li>
				</ul>
			</div>
			
			<div v-if="continuePodcasts.length>0" class="flex flex-col gap-6">
				<h2 class="font-bold text-xl md:text-3xl mt-6">Fortsätt lysna</h2>
				<ul class="grid grid-cols-2 md:grid-cols-3 gap-6">
					<li v-for="episode in continuePodcasts.slice(0,3)" :key="episode.linkid" class="flex flex-row gap-3 items-center">
						<EpisodeCard :episode="episode" :play="false" :orientation="'vertical'" />
					</li>
				</ul>
			</div>
		</section>
		
		<section class="flex-1 bg-light-blue rounded-xl p-6 flex flex-col gap-3">
			<h2 class="font-bold text-xl md:text-3xl">Nyheter</h2>
			<ul v-if="store.news" class="flex flex-col">
				<li v-for="news in store.news.slice(0, 3)" :key="news.link" class="not-last:border-b border-gray-500 py-3">
					<a rel="noopener noreferrer" target="_blank" :href="news.link" class="podcast-card flex flex-col gap-1 hover:opacity-75">
						<span class="text-red text-xs font-bold uppercase leading-5">{{ news.category }}</span>
						<time :datetime="news.date" class="text-xs uppercase leading-5">{{ format(new Date(news.date), 'yyyy-MM-dd HH:mm') }}</time>
						<h3 class="text-base font-bold leading-tight">{{ news.title }}</h3>
					</a>
				</li>
			</ul>
			<hr class="border-white" />
			<h2 class="font-bold text-xl md:text-3xl mt-3">Kalender</h2>
			<ul v-if="store.events.items" class="flex flex-col">
				<li v-for="event in store.events.items.slice(0, 3)" :key="event.link" class="not-last:border-b border-gray-500 py-3">
					<a rel="noopener noreferrer" target="_blank" :href="event.link" class="flex flex-col gap-1 hover:opacity-75">
						<span class="text-red text-xs font-bold uppercase leading-5">{{ event.organizer }}</span>
						<div class="flex flex-row gap-3 leading-5">					
							<span class="text-xs uppercase leading-5">{{ format(new Date(event.start_time), 'yyyy-MM-dd HH:mm') }}</span>
							<span class="text-xs uppercase leading-5" v-for="location in event.locations" :key="location">{{ location }}</span>
						</div>
						<h3 class="text-base font-bold leading-tight">{{ event.title }}</h3>
					</a>
				</li>
			</ul>
		</section>
	</div>
</template>

<script setup>
	import { computed } from 'vue'
	import { usePodcastStore } from '../stores/podcastStore'
	import { format } from 'date-fns'
	import EpisodeCard from '@/components/EpisodeCard.vue'
	const store = usePodcastStore()
	
	const continuePodcasts = computed(() => {
		const validIds = Object.keys(store.playbackPositions).filter(id => id !== 'undefined')
		return store.episodes.filter(episode => validIds.includes(episode.linkid))
	})
</script>